<template>
  <component
    :is="wrapper || 'div'"
    v-show="mode !== FiltersMode.catalog || filteredChildCategories.length"
    v-bind="props"
    class="categories-filter"
  >
    <list>
      <template v-if="mode === FiltersMode.boxFinder">
        <zaproo-checkbox
          v-for="optionCategory of filter.options"
          :key="optionCategory.value"
          :model-value="optionCategory.selected"
          :name="`category-${optionCategory.value}`"
          class="categories-filter-item py-2 pl-4 pr-3"
          @update:model-value="
            filterManager.toggleOption(filter.key, optionCategory.value)
          "
        >
          <span class="mr-1 text-base font-normal text-zinc-900">{{
            optionCategory.name
          }}</span>
          <span class="text-base font-normal text-zinc-500"
            >({{ optionCategory.count }})</span
          >
        </zaproo-checkbox>
      </template>
      <template v-else-if="!mode || mode === FiltersMode.search">
        <list-item
          v-for="optionCategory of filter.options"
          :key="optionCategory.value"
          :active="optionCategory.selected"
          class="categories-filter-item font-normal"
          @click="filterManager.toggleOption(filter.key, optionCategory.value)"
        >
          <span class="mr-1 font-normal text-zinc-900">{{
            optionCategory.name
          }}</span>
          <span class="font-normal text-zinc-500"
            >({{ optionCategory.count }})</span
          >
        </list-item>
      </template>
      <template v-else>
        <list-item
          v-for="item of filteredChildCategories"
          :key="item.category.uid"
          :link="catalogLinker.categoryLink(item.category)"
          class="categories-filter-item font-normal"
        >
          <span class="mr-1 font-normal text-zinc-900">{{
            item.category.name
          }}</span>
          <span class="font-normal text-zinc-500"
            >({{ item.klevuOption.count }})</span
          >
        </list-item>
      </template>
    </list>
  </component>
</template>
<script lang="ts" setup>
import type { FilterManager, KlevuFilterResultOptions } from "@klevu/core";
import type { Component } from "vue";
import { FiltersMode } from "~/modules/catalog/components/Filter/types";
import type { CategoryFull, CategoryShort } from "~/types/category";

const props = defineProps<{
  wrapper?: Component;
  filter: KlevuFilterResultOptions;
  filterManager: FilterManager;
  mode?: FiltersMode;
  category?: CategoryFull;
}>();

const catalogLinker = useCatalogLinker();
const filteredChildCategories = computed(() => {
  const res: {
    category: CategoryShort;
    klevuOption: KlevuFilterResultOptions["options"][number];
  }[] = [];

  if (!props.category) {
    return res;
  }

  for (const child of props.category.children || []) {
    const klevuOption = props.filter.options.find((o) => o.name === child.name);

    if (klevuOption) {
      res.push({
        category: child,
        klevuOption,
      });
    }
  }

  return res;
});
</script>
<style lang="scss">
.categories-filter {
  ul.list {
    li button,
    a {
      @apply p-4;
    }
  }
}
</style>
